
export default function IconReset() {
  return (
    <svg
      id="fi_18312877"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"      
    >
      <linearGradient
        id="linear-gradient"
        gradientUnits="userSpaceOnUse"
        x1="368.786"
        x2="178.641"
        y1="93.576"
        y2="422.917"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="368.794"
        x2="178.649"
        href="#linear-gradient"
        y1="93.581"
        y2="422.922"
      ></linearGradient>
      <path
        d="m322.854 192.826c-.028-1.162-.68-2.183-1.729-2.665-72.17-33.392-177.506 4.365-177.506 100.658 0 27.326 9.099 51.024 23.839 69.817 61.824 78.803 222.917 71.036 227.367-118.346.029-1.474 1.106-2.693 2.551-2.891 1.446-.227 2.806.595 3.288 1.984 5.301 15.506 8.164 32.145 8.164 49.436 0 84.501-68.485 152.986-152.958 152.986s-152.986-68.485-152.986-152.986c0-109.417 108.312-192.614 213.449-180.454.85.114 1.644-.113 2.296-.68s1.02-1.304 1.049-2.183l1.361-36.425c.028-1.162.708-2.154 1.786-2.636 1.106-.454 2.296-.283 3.175.51l82.092 71.943c.624.539.964 1.276 1.02 2.098.028.85-.255 1.587-.822 2.211l-39.543 42.378-22.45 24.038-17.773 19.049c-.85.907-2.126 1.19-3.288.765-1.162-.454-1.899-1.531-1.899-2.778l-.482-35.83z"
        fill="url(#linear-gradient)"
      ></path>
      <path
        d="m322.854 192.826c0-1.191-.652-2.183-1.729-2.693-72.17-33.364-177.477 4.394-177.477 100.687 0 27.326 9.071 51.024 23.811 69.817 61.824 78.803 222.917 71.008 227.367-118.346.057-1.474 1.105-2.693 2.551-2.891 1.446-.227 2.835.595 3.288 1.984 5.301 15.505 8.192 32.145 8.192 49.436 0 84.501-68.513 152.986-152.986 152.986s-152.986-68.485-152.986-152.986c0-109.417 108.312-192.614 213.449-180.454.879.113 1.644-.113 2.296-.68.68-.567 1.021-1.304 1.049-2.183l1.361-36.425c.028-1.162.709-2.154 1.814-2.636 1.077-.454 2.268-.283 3.146.51l82.091 71.943c.624.539.964 1.247 1.021 2.098.028.85-.227 1.587-.822 2.211l-39.543 42.378-22.422 24.038-17.802 19.049c-.85.907-2.098 1.191-3.26.737-1.19-.425-1.899-1.502-1.928-2.75l-.482-35.83z"
        fill="url(#linear-gradient-2)"
        fillRule="evenodd"
      ></path>
    </svg>
  );
}
